"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPaybackCollect = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackPaybackCollect(collected) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        withPaybackCollect: collected ? 'yes' : 'no',
    });
}
exports.trackPaybackCollect = trackPaybackCollect;
//# sourceMappingURL=trackPaybackCollect.js.map